var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 67,
    viewBox: "0 0 38 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "33.953%",
    x2: "57.129%",
    y1: "0%",
    y2: "88.079%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7D56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#67FFE4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "evenodd",
    d: "M12.184 43.251l9.84 11.02-6.946 11.658c-5.9-4.668-7.742-12.82-4.422-19.572l1.528-3.106zM3.437 26.502l19.008 21.48c1.184 1.338 1.346 3.295.399 4.81l-.53.845L5.493 34.412c-1.894-2.165-2.656-5.097-2.055-7.91zM1.335 7.25l3.296 5.613c.157.267.321.53.493.787l19.76 29.733c.734 1.105.866 2.505.351 3.728l-.109.259c-.247.586-.922.861-1.509.614-.161-.068-.305-.171-.42-.303L4.828 26.668C.168 21.337-1.175 13.87 1.335 7.25zM4.937.025l19.762 34.128c1.148 1.983 1.753 4.233 1.753 6.524v1.597c0 .318-.258.576-.576.576-.192 0-.372-.096-.479-.256L6.475 14.254C3.667 10.046 3.093 4.733 4.937.024zM32.46 24.962c1.863 0 3.487 1.036 4.336 2.567.4.722.628 1.553.628 2.439 0 2.764-2.222 5.005-4.964 5.005-2.742 0-4.965-2.241-4.965-5.005 0-2.765 2.223-5.006 4.965-5.006z",
    transform: "translate(.5 .25)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconH);
export default __webpack_public_path__ + "static/media/icon-h.e53298f3badc29e0c89bc5015e6d79ee.svg";
export { ForwardRef as ReactComponent };